import React, { useState } from 'react';
import { recipes } from '../services/api';
import '../styles/FavoriteButton.css';

const FavoriteButton = ({ recipeId, initialFavorited = false, onToggle }) => {
  const [isFavorited, setIsFavorited] = useState(initialFavorited);
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      alert('Jelentkezz be a kedvencek használatához!');
      return;
    }

    setLoading(true);
    try {
      const response = await recipes.toggleFavorite(recipeId);
      setIsFavorited(response.data.isFavorited);
      if (onToggle) onToggle(response.data.isFavorited);
    } catch (error) {
      console.error('Favorite toggle error:', error);
      alert('Hiba történt a kedvenc állapot módosításakor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      className={`favorite-btn ${isFavorited ? 'favorited' : ''}`}
      title={isFavorited ? 'Eltávolítás a kedvencek közül' : 'Hozzáadás a kedvencekhez'}
    >
      {isFavorited ? '⭐' : '☆'} Kedvenc
    </button>
  );
};

export default FavoriteButton;
